package com.devi3east.bashbuddy.ktor.stripe.responses

import kotlinx.serialization.Serializable

@Serializable
data class CreateAccountLinkResponse(
    val url: String
)
